import { render } from "./employeeFiles.vue?vue&type=template&id=7321c548&ts=true"
import script from "./employeeFiles.vue?vue&type=script&lang=ts"
export * from "./employeeFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__